import React, { useEffect, useState } from 'react';
import voca from 'voca';
import { toast } from 'react-toastify';
import RestAPICollectionFieldsModal from '../../external-api/rest-api/RestAPICollectionFieldsModal';

export const MappingRow = ({
  createNewParamRow,
  row,
  projectDetail,
  collection,
  collections,
  isReadOnly,
}) => {
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setKey(row.key);
    setValue(row.value);
  }, [row]);

  const onKeyChange = (e) => {
    setKey(voca.trim(e.target.value));
    row.key = voca.trim(e.target.value);
    createNewParamRow(row);
  };
  const onValueChange = (e) => {
    setValue(e.target.value);
    row.value = e.target.value;
    createNewParamRow(row);
  };
  const deleteRow = () => {
    setKey('');
    row.key = '';
    setValue('');
    row.value = '';
  };

  const toggleShowModal = () => setShowModal(!showModal);

  const copyToClipboard = () => {
    toggleShowModal();
    toast.success('Copied to clipboard');
  };

  const insertTextToParamInput = (textToInsert) => {
    if (textToInsert) {
      const InputElem = document.getElementById(`value${row.id}`);
      let start = InputElem.selectionStart;
      // obtain the index of the last selected character
      let finish = InputElem.selectionEnd;
      //obtain all Text
      let allText = InputElem.value;
      // obtain the selected text
      let sel = allText.substring(start, finish);
      let newText = '';
      if (sel) {
        newText = allText.replace(sel, textToInsert);
      } else {
        newText = allText + textToInsert;
      }
      toggleShowModal();
      setValue(newText);
      row.value = newText;
      toast.success('Inserted Value');
    }
  };

  const showCollectionFieldModal = () => {
    return (
      <RestAPICollectionFieldsModal
        selectedCollection={collection}
        collections={collections}
        copyToClipboard={copyToClipboard}
        insertTextToEditor={insertTextToParamInput}
        toggleFields={showModal}
        toggleFieldsModal={toggleShowModal}
        projectDetail={projectDetail}
        hide={[
          'collectionConstants',
          'projectConstants',
          'userDerivedFields',
          'userFields',
          'authToken',
          'tenantFields',
          'userSettingFields',
          'subTenantFields',
        ]}
        showReferenceFieldInRF={true}
      />
    );
  };

  return (
    <>
      {showModal && showCollectionFieldModal()}
      <div className="col-md-4 col-lg-4">
        <input
          type="text"
          name="key"
          value={key}
          className="form-control form-control-sm"
          onChange={onKeyChange}
          placeholder="Key"
        />
      </div>
      <div className="col-md-8 col-lg-8">
        <div className="input-group">
          <input
            type="text"
            name="value"
            value={value}
            className="form-control form-control-sm"
            onChange={onValueChange}
            placeholder="Value"
            id={`value${row.id}`}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <button
                type="button"
                className="btn btn-theme-submit btn-xs btn-icon-only"
                title={isReadOnly ? 'Read-Only Mode' : 'Add Fields'}
                onClick={() => (isReadOnly ? null : setShowModal(true))}
                disabled={isReadOnly}
              >
                <i className="wb webconnect-plus" />
              </button>
              <button
                type="button"
                className="btn btn-xs btn-theme-delete btn-icon-only ml-1"
                title={isReadOnly ? 'Read-Only Mode' : 'Delete Fields'}
                onClick={() => (isReadOnly ? null : deleteRow())}
                disabled={isReadOnly}
              >
                <i className="wb webconnect-times " />
              </button>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
